{
  "Accessibility menu": "Prieinamumo meniu",
  "Close": "Uždaryti",
  "Content adjustments": "Turinio koregavimai",
  "Navigation adjustments": "Navigacijos koregavimai",
  "Align Left": "Lygiuoti kairėje",
  "Adjust Font Size": "Koreguoti šrifto dydį",
  "Highlight Title": "Paryškinti antraštę",
  "Highlight Links": "Paryškinti nuorodas",
  "Readable Font": "Skaitytinas šriftas",
  "Colour adjustments": "Spalvų koregavimai",
  "Dark Contrast": "Tamsus kontrastas",
  "Light Contrast": "Šviesus kontrastas",
  "High Contrast": "Aukštas kontrastas",
  "High Saturation": "Aukštas prisotinimas",
  "Low Saturation": "Žemas prisotinimas",
  "Monochrome": "Vienaspalvė",
  "Tools": "Įrankiai",
  "Reading Guide": "Skaitymo gidas",
  "Big Cursor": "Didelis žymeklis",
  "Increase Font Size": "Padidinti šrifto dydį",
  "Decrease Font Size": "Sumažinti šrifto dydį",
  "Letter Spacing": "Raidžių tarpai",
  "Line Height": "Eilučių aukštis",
  "Font Weight": "Šrifto storis",
  "Dyslexia Font": "Disleksijos šriftas",
  "Language": "Kalba",
  "Accessibility widget": "Prieinamumo valdiklis",
  "Accessibility Profiles": "Prieinamumo profiliai",
  "Cognitive Disability": "Kognityvinis negalavimas",
  "Seizure Safe": "Saugus nuo priepuolių",
  "Accessibility statement": "Prieinamumo pareiškimas",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Sustabdyti animacijas",
  "Reset all settings": "Atkurti nustatymus",
  "Shortcut:": "Shortcut:"
}
